import { BaseMessageConfig } from '@/shared/types/message';

export const defaultMessageConfig: BaseMessageConfig = {
  duration: 5000,
  maxMessages: 5,
  position: 'bottom-right',
  variant: 'outlined',
  primaryButtonText: 'Aceptar',
  secondaryButtonText: 'Cancelar',
  animationDuration: 300,
  size: 'sm',
};

export let messageConfig: BaseMessageConfig = { ...defaultMessageConfig };

export const configureMessage = (newConfig: Partial<BaseMessageConfig>) => {
  messageConfig = { ...messageConfig, ...newConfig };
};
